module.exports = __webpack_public_path__ + "static/img/innovate-b.71f8ade3.png";